import { z } from "zod";
import {
  emailField,
  confirmEmailField,
  firstNameField,
  lastNameField,
  passwordField,
  confirmPasswordField,
  currentPasswordField,
  loginPasswordField,
  phoneNumberField,
  confirmPhoneNumberField,
} from "@core/schemas/fields";
import {
  withEmailConfirmation,
  withPasswordConfirmation,
  withPhoneConfirmation,
} from "@core/schemas/refinements";

/**
 * Signup schema fields (without phone)
 */
export const signupSchemaBaseFields = {
  firstName: firstNameField,
  lastName: lastNameField,
  email: emailField,
  confirmEmail: confirmEmailField,
  password: passwordField,
};

/**
 * Signup schema fields with optional phone number
 */
export const signupSchemaWithPhoneFields = {
  ...signupSchemaBaseFields,
  phoneNumber: phoneNumberField,
  confirmPhoneNumber: confirmPhoneNumberField,
};

/**
 * Login schema fields
 */
export const loginSchemaBaseFields = {
  email: emailField,
  password: loginPasswordField,
};

/**
 * Forgot password schema fields
 */
export const forgotPasswordSchemaBaseFields = {
  email: emailField,
};

/**
 * Reset password schema fields
 */
export const resetPasswordSchemaBaseFields = {
  password: passwordField,
  confirmPassword: confirmPasswordField,
};

/**
 * Update password schema fields
 */
export const updatePasswordSchemaBaseFields = {
  currentPassword: currentPasswordField,
  password: passwordField,
  confirmPassword: confirmPasswordField,
};

/**
 * Signup schema with email confirmation validation
 */
export const baseSignupSchema = withEmailConfirmation(
  z.object(signupSchemaBaseFields)
);

/**
 * Signup schema with phone number and email confirmation validation
 */
export const signupSchemaWithPhone = withPhoneConfirmation(
  withEmailConfirmation(z.object(signupSchemaWithPhoneFields))
);

/**
 * Login schema
 */
export const baseLoginSchema = z.object(loginSchemaBaseFields);

/**
 * Forgot password schema
 */
export const baseForgotPasswordSchema = z.object(
  forgotPasswordSchemaBaseFields
);

/**
 * Reset password schema with password confirmation validation
 */
export const baseResetPasswordSchema = withPasswordConfirmation(
  z.object(resetPasswordSchemaBaseFields)
);

/**
 * Update password schema with password confirmation validation
 */
export const baseUpdatePasswordSchema = withPasswordConfirmation(
  z.object(updatePasswordSchemaBaseFields)
);

